<template>
  <md-button
    class="md-primary"
    v-if="mostra_status"
    type="button"
    v-bind:disabled="disableButton"
    v-on:click="onclick_status"
  >{{ status != 1 ? "Publicar" : "Despublicar" }}</md-button> 
</template>

<script>
import service from "../../services/InspecaoService";
import Alerta from "../../library/Alerta";

import Swal from "sweetalert2";
export default {
  props: {
    status: {},
    disableButton: {},
    onClick: {}
  },
  model: {
    prop: "status",
    event: "selected"
  },
  data() {
    return {
      mostra_status: true,
      nome_perfil: ""
    };
  },
  mounted() {
    let self = this;
    this.showbutton();
  },
  methods: {
    showbutton(){
        let user = JSON.parse(window.obj_user.getUser());
        var codigo_perfil = "";

        if ( user.perfil_codigo ){
          codigo_perfil = user.perfil_codigo;
        }

        if (
          codigo_perfil.toString() != "1" &&
          user.perfil.toLowerCase().indexOf("administrador") < 0 &&
          user.perfil.toLowerCase().indexOf("supervisor") < 0 
        ) {
          this.mostra_status = false;
        }

        if ( this.status != 1 && ( user.perfil.toLowerCase().indexOf("técnico") > -1 || codigo_perfil.toString() == "TEC" || codigo_perfil.toString() == "2" || codigo_perfil.toString() == "1" )  ){
          
          this.mostra_status = true;
        }

        this.nome_perfil = user.perfil;
    },
    onclick_status() {
      var self = this;
      if (this.onClick != null) {
        var final = 1;

        if (this.status == 1) {
          final = 0;
        }

        if (
          final == 1 &&
          this.nome_perfil.toLowerCase().indexOf("administrador") < 0 &&
          this.nome_perfil.toLowerCase().indexOf("supervisor") < 0
        ) {
          var msg =
            "Após publicar não será mais possível salvar. Deseja continuar?";

          Alerta.confirm(
            "Atenção",
            msg,
            "question",
            function() {
              
               self.mostra_status = false;
              self.onClick(final, self.nome_perfil);
            },
            null
          );
        } else {
          this.onClick(final, this.nome_perfil);
        }
      }
    }
  }
};
</script>